import {useCallback, useEffect, useState} from "react";

import {
    IRecentMapRegionSearch,
    readRecentMapRegionSearches,
    RecentMapRegionSearchInput,
    subscribeRecentMapRegionSearches,
    upsertRecentMapRegionSearch,
    writeRecentMapRegionSearches
} from "../utils/recent_map_region_storage";

export type {IRecentMapRegionSearch, RecentMapRegionSearchInput} from "../utils/recent_map_region_storage";

export const useRecentMapRegionSearches = () => {
    const [recentSearches, setRecentSearches] = useState<IRecentMapRegionSearch[]>(readRecentMapRegionSearches);

    useEffect(() => subscribeRecentMapRegionSearches(() => setRecentSearches(readRecentMapRegionSearches())), []);

    const addRecentSearch = useCallback((entry: RecentMapRegionSearchInput) => {
        setRecentSearches((current) => {
            const next = upsertRecentMapRegionSearch(current, entry);
            writeRecentMapRegionSearches(next);
            return next;
        });
    }, []);

    const removeRecentSearch = useCallback((regionId: number) => {
        setRecentSearches((current) => {
            const next = current.filter((item) => item.regionId !== regionId);
            writeRecentMapRegionSearches(next);
            return next;
        });
    }, []);

    return {recentSearches, addRecentSearch, removeRecentSearch};
};
